import React from 'react'
import { Box, BoxProps, styled } from '@mui/material'
import { Link, LinkProps } from 'react-router'

type SidebarLogoProps = BoxProps & Omit<LinkProps, 'to'> & {
  to?: string;
}

const SidebarLogo = styled(
  ({ to, ...props }: SidebarLogoProps) => (
    <Box {...props} component={Link} to={to || '/'}>
      СпецТехника
    </Box>
  )
)(
  ({ theme: { palette }}) => ({
    border: `1px solid ${palette.secondary.contrastText}`,
    borderRadius: 8,
    color: palette.secondary.contrastText,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '37px',
    margin: '27px 34px 0 28px',
    textAlign: 'center',
    textDecoration: 'none',
  })
)

export default SidebarLogo